<template>
  <div id="weekPlan">
    <navBar
      :tags="tags"
      :title="titleName"
      :subTitle="subTitle"
      :btnBack="false"
      @btnSum="handleAddSum"
      :btnSum="configObj.isShowSummary"
      @btnTod="handleAddTod"
      :btnTod="configObj.isShowPlan"
      @btnTom="handleAddTom"
      :btnTom="configObj.isShowNextPlan"
    />
    <el-row style="height: 250px;border-bottom:2px dotted #e7eaec; padding-top:10px">
      <el-col :span="24" style="margin-top: 1px">
        <el-row>
          <el-col :span="13" style="position: relative">
            <span style="margin-right: 10px;font-weight: bold;display: inline-block;width: 70px">计划日期</span>
            <div style="display: inline-block;width: calc(100% - 120px) ">
              <el-date-picker
                v-model="start_time"
                type="date"
                placeholder="选择日期"
                format="yyyy-M-d"
                value-format="yyyy-MM-dd"
                style="width: 45%"
              >
              </el-date-picker
              ><span style="display: inline-block;width: 10%;text-align: center">至</span
              ><el-date-picker
                v-model="end_time"
                type="date"
                placeholder="选择日期"
                format="yyyy-M-d"
                value-format="yyyy-MM-dd"
                style="width: 45%"
              >
              </el-date-picker>
            </div>
          </el-col>
          <el-col style="line-height: 40px;margin-top: 10px">
            <span style="font-weight: bold;margin-right: 10px;display: inline-block;width: 70px">计划评价</span>
            <el-checkbox-group style="display: inline-block" v-model="checkListArray" @change="ladderChange">
              <el-checkbox label="SUBMITTED">是</el-checkbox>
              <el-checkbox label="DRAFT">否</el-checkbox>
            </el-checkbox-group>

            <span style="font-weight: bold;margin-right: 10px;margin-left: 50px;display: inline-block;width: 70px"
              >小结评价</span
            >
            <el-checkbox-group style="display: inline-block" v-model="titleArray" @change="ladderChange">
              <el-checkbox label="SUBMITTED">是</el-checkbox>
              <el-checkbox label="DRAFT">否</el-checkbox>
            </el-checkbox-group>
          </el-col>
          <div style="position: absolute;right: 0;" v-if="this.role != 'staff'">
            <span style="font-weight: bold;margin-right: 10px">人员</span>
            <el-select
              v-if="title !== '管理员'"
              v-model="selectPeople"
              clearable
              v-on:change="handleSelectInputClick"
              :disabled="title !== '管理员'"
              placeholder=""
              style="width: 160px"
            >
              <el-option
                v-for="(item, index) in options"
                :key="item.user_id"
                :label="item.user_name"
                :value="item.user_id"
              >
              </el-option>
            </el-select>
            <inputSelect :handleSelectInput="handleSelectInputClick" v-if="title === '管理员'"></inputSelect>
          </div>
        </el-row>
      </el-col>
      <el-row style="margin-top: 200px">
        <el-col :span="24">
          <el-button type="primary" size="small" @click="searchWeekList">查询</el-button>
          <el-button type="danger" size="small" @click="ResetClick">重置</el-button>
        </el-col>
      </el-row>
    </el-row>
    <el-row>
      <el-col>
        <el-table
          :header-cell-style="{ color: 'black', 'font-size': '15px' }"
          id="weekPlan_table"
          stripe
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column align="center" fixed type="index" label="序号"></el-table-column>
          <el-table-column prop="plan_date" label="日期" sortable> </el-table-column>
          <el-table-column prop="user_name" label="人员" sortable> </el-table-column>
          <el-table-column prop="plan_details" label="每日计划" sortable> </el-table-column>
          <el-table-column prop="plan_comment" label="计划已评价" sortable> </el-table-column>
          <el-table-column prop="summary_details" label="每日小结" sortable> </el-table-column>
          <el-table-column prop="summary_comment" label="小结已评价" sortable> </el-table-column>
          <el-table-column label-class-name="weekPlan_table_cell" label="操作">
            <template slot-scope="scope">
              <div style="width: 100%;text-align: center">
                <el-button @click="weekplanInfo(scope.row)" type="warning" style="text-align: center" size="small"
                  >详情
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col style="margin-bottom: 20px">
        <pagination :page="page" @changePage="changePageClick"></pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import navBar from '../../../components/navBar'
import http from '../../../APIService/http'
import pagination from '../../../components/pagination'
import inputSelect from './components/inputSelect'
import moment from 'moment'
export default {
  name: 'weekplan',
  components: {
    navBar,
    pagination,
    inputSelect,
  },
  data() {
    return {
      role: '',
      openModelSelect: true,
      tags: ['日程安排'],
      titleName:
        this.$store.getters.getUser.role === 'staff'
          ? this.$store.getters.getUser.alias
          : this.GLOBAL.peopleName_global,
      title: this.$store.getters.getUser.role === 'staff' ? this.$store.getters.getUser.alias : '管理员',
      subTitle: '计划小结',
      start_time: '',
      start_timeDate: '',
      end_time: '',
      end_timeDate: '',
      options: [],
      selectPeople: this.$store.getters.getUser.role === 'staff' ? this.$store.getters.getUser.user_id : '',
      selectPeopleManager: '',
      tableData: [],
      page: this.GLOBAL.page_weekplan,
      checkListArray: [],
      titleArray: [],
      searchForm: {},
      clientObj: {},
      configObj: {},
    }
  },
  created() {
    this.role = this.$store.getters.getUser.role
    this.clientObj = this.$store.getters.getClient
    this.init()
    this.getManager()
  },
  updated() {},
  watch: {
    start_time(newVal, oldVal) {
      if (newVal != '' && newVal != null) {
        this.start_timeDate = moment(newVal)
          .subtract(1, 'days')
          .format('YYYY-MM-DD')
      } else {
        this.start_timeDate = ''
      }
    },
    end_time(newVal, oldVal) {
      if (newVal != '' && newVal != null) {
        let date = moment(newVal).format('YYYY-MM-DD')
        let days = moment(date).format('E')
        this.end_timeDate = moment(date)
          .subtract(days - 7, 'days')
          .format('YYYY-MM-DD') //周日日期
      } else {
        this.end_timeDate = ''
      }
    },
  },
  methods: {
    getActivityPlanSummaryParameter() {
      let data = {
        user_id: this.$store.getters.getUser.user_id,
        tenant_id: this.$store.getters.getUser.tenant_id,
        plan_date: moment(new Date()).format('YYYY-MM-DD'),
      }
      //let { tenant_id, user_id, plan_date } = data;
      http.post('/crm/activity/plan_summary/getActivityPlanSummaryParameter', data).then((res) => {
        if (res.success === true) {
          this.configObj = res.data
          debugger
          this.initConig()
        } else {
        }
      })
    },
    initConig() {
      let currentDate = new Date().toTimeString()
      if (this.configObj.isShowPlan) {
        //判断当天计划截止创建时间
        if (this.time_to_sec(this.configObj.parameter.PLAN_SUMMARY_PLAN_CLOSE_TIME) < this.time_to_sec(currentDate)) {
          this.configObj.isShowPlan = false
        }
        if (this.configObj.territoryList.length == this.configObj.planNum.length) {
          this.configObj.isShowPlan = false
        }
      }
      if (this.configObj.isShowSummary) {
        //判断当天小结开始创建时间
        if (
          this.time_to_sec(this.configObj.parameter.PLAN_SUMMARY_SUMMARY_START_TIME) > this.time_to_sec(currentDate)
        ) {
          this.configObj.isShowSummary = false
        }
        if (this.configObj.territoryList.length == this.configObj.summaryNum.length) {
          this.configObj.isShowSummary = false
        }
      }
      if (this.configObj.isShowNextPlan) {
        if (this.configObj.parameter.ENABLE_TOMORROW_PLAN_SUMMARY == 'F') {
          this.configObj.isShowNextPlan = false
        }
        if (this.configObj.territoryList.length == this.configObj.nextplanNum.length) {
          this.configObj.isShowNextPlan = false
        }
      }
    },
    time_to_sec(time) {
      if (time !== null) {
        var s = ''
        var hour = time.split(':')[0]
        var min = time.split(':')[1]
        // var sec = time.split(":")[2];
        // s = Number(hour * 3600) + Number(min * 60) + Number(sec);
        s = Number(hour * 3600) + Number(min * 60)
        return s
      }
    },
    changePageClick(page, size) {
      if (page) {
        this.page.current = page
      }
      if (size) {
        this.page.size = size
      }

      this.init()
    },
    async init() {
      let loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      debugger
      try {
        let data = {
          territory_manage_id: '',
          offset: this.page.current - 1,
          start_date: this.start_time ? this.start_time : '',
          end_date: this.end_time ? this.end_time : '',
          is_plan_comments: this.checkListArray.length == 0 ? '' : this.checkListArray[0] == 'SUBMITTED' ? 'T' : 'F',
          is_summary_comments: this.titleArray.length == 0 ? '' : this.titleArray[0] == 'SUBMITTED' ? 'T' : 'F',
          // is_plan_comments: '',
          // is_summary_comments: '',
          user_id: this.$store.getters.getUser.user_id,
          tenant_id: this.$store.getters.getUser.tenant_id,
        }
        if (this.$store.getters.getUser.role === 'staff') {
          data.owner_id = this.selectPeople
        } else {
          data.owner_id = this.GLOBAL.selectPeople_global
          if (this.GLOBAL.selectOu_global != '') {
            data.owner_id = ''
            data.ou_id = this.GLOBAL.selectOu_global
          }
        }
        data.role = this.$store.getters.getUser.role
        debugger
        await http.post('/crm/activity/plan_summary/getWebPlanSummaryList', data).then((res) => {
          if (res.success == true) {
            this.page.total = res.data.resultCount
            let array = res.data
            debugger
            this.judeg(array)
            loading.close()
            this.getActivityPlanSummaryParameter()
          }
        })
      } catch (e) {
        loading.close()
      }
    },
    async getManager() {
      try {
        let data = {
          user_id: this.$store.getters.getUser.user_id,
          tenant_id: this.$store.getters.getUser.tenant_id,
        }
        await http.post('/wapi/Calendar/getManger', data).then((res) => {
          this.options = res.data
          let obj = {
            user_id: '',
            user_name: '所有下属',
          }
          this.options.unshift(obj)
        })
      } catch (e) {}
    },
    searchWeekList() {
      this.page = {
        current: 1,
        size: 5,
        total: 0,
      }
      this.init()
    },
    judeg(arr) {
      let array = arr
      // console.log(array)
      for (let i = 0; i < array.length; i++) {
        let obj = array[i]
        obj.num = i + 1
        obj.time = moment(obj.start_date).format('YYYY年M月D日') + ' - ' + moment(obj.end_date).format('M月D日')
        obj.business_num = '无'
        if (parseInt(obj.institution_num) === 0 || obj.institution_num == 0) {
          obj.institution_num = '无'
        } else {
          obj.institution_num = obj.institution_num + '家'
        }
        if (parseInt(obj.distributor_num) === 0 || obj.distributor_num === 0) {
          obj.distributor_num = '无'
        } else {
          obj.distributor_num = obj.distributor_num + '家'
        }
        if (parseInt(obj.store_num) === 0 || obj.store_num === 0) {
          obj.store_num = '无'
        } else {
          obj.store_num = obj.store_num + '家'
        }
        if (parseInt(obj.meeting_num) === 0 || obj.meeting_num === 0) {
          obj.meeting_num = '无'
        } else {
          obj.meeting_num = obj.meeting_num + '场'
        }
        if (parseInt(obj.coaching_num) === 0 || obj.coaching_num === 0) {
          obj.coaching_num = '无'
        } else {
          obj.coaching_num = obj.coaching_num + '场'
        }

        if (obj.status === 'SUBMITTED') {
          obj.confirmed_resultText = '待审核'
          obj.color = '#FF9901'
        }
        if (obj.status === 'APPROVED') {
          obj.confirmed_resultText = '已批准'
          obj.color = 'green'
        }
        if (obj.status === 'DENIED') {
          obj.confirmed_resultText = '已拒绝'
          obj.color = 'red'
        }
        if (obj.status === 'DRAFT' || obj.status === 'ACTIVE') {
          obj.confirmed_resultText = '未提交'
          obj.color = '#606266'
        }
      }
      this.tableData = array
    },
    handleSelectInputClick(j) {
      for (let i = 0; i < this.options.length; i++) {
        if (j === this.options[i].user_id) {
          this.titleName = this.options[i].user_name
        }
      }
      debugger
      this.GLOBAL.selectPeople_global = j
      this.titleName = this.GLOBAL.peopleName_global
      this.init()
    },
    weekplanInfo(row) {
      debugger
      row.type = 'det'
      row.titleName = this.titleName
      this.GLOBAL.page_weekplan = this.page
      this.searchForm = row
      this.$router.push({
        name: 'planSummaryInfo',
        params: {
          row: row,
          configObj: this.configObj,
        },
      })
    },
    handleAddSum() {
      let row = {
        type: 'sum',
      }
      this.$router.push({
        name: 'planSummaryInfo',
        params: {
          row: row,
          configObj: this.configObj,
        },
      })
    },
    handleAddTod() {
      debugger
      let row = {
        type: 'tod',
      }
      this.$router.push({
        name: 'planSummaryInfo',
        params: {
          row: row,
          configObj: this.configObj,
        },
      })
    },
    handleAddTom() {
      let row = {
        type: 'tom',
      }
      this.$router.push({
        name: 'planSummaryInfo',
        params: {
          row: row,
          configObj: this.configObj,
        },
      })
    },
    handleAdd() {
      let row = {
        type: 'new',
      }
      this.$router.push({ name: 'planSummaryInfo', params: row })
    },
    ResetClick() {
      this.start_time = ''
      this.end_time = ''
      this.checkListArray = []
      this.titleArray = []
      this.init()
    },
    ladderChange() {
      // if (this.checkListArray.length>1){
      //     this.checkListArray.shift()
      // }
      // console.log(this.checkListArray,111)
    },
  },
  beforeRouteLeave(to, from, next) {
    // 打开详情页（或者下一个任意界面）之前，把筛选条件保存到localStorage，如果离开列表页并且打开的不是详情页则清除，也可以选择不清除
    if (to.name === 'planSummaryInfo' && to.params.type != 'new') {
      // console.log(this.searchForm)
      let condition = JSON.stringify(this.searchForm)
      localStorage.setItem('condition', condition)
    } else {
      localStorage.removeItem('condition')
    }

    if (to.name !== 'planSummaryInfo') {
      this.GLOBAL.page_weekplan = {
        current: 1,
        size: 5,
        total: 0,
      }
    }
    next()
  },
}
</script>

<style>
#weekPlan_table th {
  padding: 7px 0;
}
</style>
<style scoped>
#weekPlan_table >>> .weekPlan_table_cell {
  color: #2b92fa !important;
}
#weekPlan >>> .el-button--warning {
  color: #fff;
  background-color: #ff9901;
  border-color: #ff9901;
}
#weekPlan >>> .el-button--warning:hover {
  background: #ebb563;
  border-color: #ebb563;
  color: #fff;
}
#weekPlan >>> .el-button {
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/pages/calendar/components/planSummary.vue